'use client';

import { isBrowser } from 'es-toolkit';
import { useEffect, useState } from 'react';

interface FormattedCurrencyProps {
	price?: number;
	currency?: string;
	className?: string;
	'data-tid'?: string;
}

export const FormattedCurrency = (props: FormattedCurrencyProps) => {
	const { price, currency = 'USD', className, ...restProps } = props;

	const [culture, setCulture] = useState<string>(() => {
		switch (currency) {
			case 'USD':
				return 'en-US';
			case 'EUR':
				return 'de-DE';
			case 'JPY':
				return 'ja-JP';
			default:
				return 'en-US';
		}
	});

	// It is important to apply user settings via useEffect to avoid hydration error (MKT-4730)
	const isClientSide = isBrowser();
	useEffect(() => {
		if (isClientSide) {
			setCulture(window.navigator.language);
		}
	}, [isClientSide]);

	const formatter = Intl.NumberFormat(culture, {
		style: 'currency',
		currency: currency ? currency : 'USD',
	});

	if (typeof price !== 'number') return null;

	return (
		<span className={className} {...restProps}>
			{formatter.format(price)}
		</span>
	);
};
